import { cn } from '@plato/ui/util/classes';

/**
 * File type color mapping based on Figma design specifications
 */
const fileTypes = {
    PDF: '#F14848', // Red
    PNG: '#4881F1', // Blue
    JPG: '#C548F1', // Purple
    XLS: '#0F8105', // Green
    GIF: '#F17048', // Orange
    MP3: '#6D56F8', // Indigo
} as const;

export type FileType = keyof typeof fileTypes;

type AttachmentIconProps = {
    /**
     * The file type to display. Determines the badge color.
     * If not provided, shows a generic file icon with horizontal lines.
     */
    fileType?: FileType;
    /**
     * Additional CSS classes to apply to the root element
     */
    className?: string;
};

/**
 * AttachmentIcon - Displays a file icon with a colored badge indicating the file type.
 */
export function AttachmentIcon({ fileType, className = '' }: AttachmentIconProps) {
    return (
        <div className={cn('h-6 w-6', className)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1369_108550)">
                    <path
                        d="M18 0L22 4V23C22 23.5523 21.5523 24 21 24H3C2.44772 24 2 23.5523 2 23V1C2 0.447715 2.44772 8.0532e-09 3 0H18Z"
                        fill="#E9F0FA"
                    />
                    <path d="M22 4H18V0L22 4Z" fill="#C2CDDE" />
                </g>
                <rect
                    x="1"
                    y="10"
                    width="22"
                    height="10"
                    rx="1"
                    fill={fileType ? fileTypes[fileType] : '#525252'}
                />
                {fileType ? (
                    <text
                        x="12"
                        y="16"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fill="white"
                        fontSize="8"
                        fontWeight="600"
                    >
                        {fileType}
                    </text>
                ) : (
                    <>
                        <path d="M5 12H19" stroke="white" strokeLinecap="round" />
                        <path d="M5 15H19" stroke="white" strokeLinecap="round" />
                        <path d="M5 18H19" stroke="white" strokeLinecap="round" />
                    </>
                )}
                <defs>
                    <clipPath id="clip0_1369_108550">
                        <rect width="20" height="24" fill="white" transform="translate(2)" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
}
